/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Contactcodetreename3Inputs */

const en_entity_contactcodetreename3 = /** @type {(inputs: Entity_Contactcodetreename3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Code Tree Name`)
};

const de_entity_contactcodetreename3 = /** @type {(inputs: Entity_Contactcodetreename3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt Code-Baum-Name`)
};

/**
* | output |
* | --- |
* | "Contact Code Tree Name" |
*
* @param {Entity_Contactcodetreename3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_contactcodetreename3 = /** @type {((inputs?: Entity_Contactcodetreename3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Contactcodetreename3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_contactcodetreename3(inputs)
	return de_entity_contactcodetreename3(inputs)
});
export { entity_contactcodetreename3 as "entity_contactCodeTreeName" }